export const Footer = () => {
    const footerLinks = [
        {
            title: "Contact Us",
            links: [
                {
                    label: "playtohealgame@gmail.com",
                    href: "mailto:playtohealgame@gmail.com",
                },
                {
                    label: "Instagram",
                    href: "https://www.instagram.com/trance4mationgames",
                },
                {
                    label: "TikTok",
                    href: "https://www.tiktok.com/@trance4mation_games",
                },
                {
                    label: "LinkedIn",
                    href: "https://www.linkedin.com/company/trance4mation-games/",
                },
            ],
        },
        {
            title: "What We Do",
            links: [
                {
                    label: "Play to Heal Hub",
                    href: "https://www.playtohealhub.com/landing",
                },
                {
                    label: "Trance4mation Nation",
                    href: "https://www.trance4mationnation.org/",
                },
                {
                    label: "Trance4mation Games",
                    href: "https://www.trance4mationgames.com/",
                },
                {
                    label: "Mission Statement",
                    href: "https://www.playtohealhub.com/landing-page/Mission.pdf",
                },
            ],
        },
    ];

    return (
        <footer className="relative overflow-hidden border-t-[5px] border-black bg-[#0f0f0f] text-white">
            <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(255,255,255,0.08)_1px,transparent_1px)] [background-size:12px_12px] opacity-30" />

            <div className="relative mx-auto max-w-7xl px-6 py-12 lg:px-8">
                <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
                    {/* Call It Out */}
                    <div className="rounded-[24px] border-[4px] border-black bg-[#e6f0ff] p-6 text-black shadow-[8px_8px_0_#000]">
                        <img
                            src="/assets/CIO_2.png"
                            alt="Call It Out"
                            className="mb-5 max-w-[220px]"
                        />

                        <p className="mb-3 text-xl font-black uppercase">
                            See It. Name It. Flip the Script.
                        </p>

                        <p className="max-w-md text-sm font-bold leading-7">
                            A bold anti-bullying dialogue game designed to empower
                            students, spark real conversations, and transform school
                            culture through empathy, confidence, and peer support.
                        </p>
                    </div>

                    {/* Trance4mation */}
                    <div className="rounded-[24px] border-[4px] border-black bg-[#f8f4ea] p-6 text-black shadow-[8px_8px_0_#000]">
                        <a href="https://www.trance4mationgames.com/" target="_blank" rel="noreferrer">
                            <img
                                src="/T4M_Logo.png"
                                alt="Trance4mation Games"
                                className="mb-4 max-w-[180px]"
                            />
                        </a>

                        <h3 className="mb-3 text-lg font-black uppercase">
                            {/* Trance4mation Games */}
                        </h3>

                        <p className="text-sm font-bold leading-7">
                            Helping over one million people to FEEL, DEAL and HEAL
                            with people in their own lives, our games are LOVE,
                            UNDERSTANDING & CONNECTION INFUSIONS.
                        </p>
                    </div>

                    {/* Links */}
                        {footerLinks.map((group) => (
                            <div
                                key={group.title}
                                className="rounded-[20px] border-[4px] border-black bg-white p-5 text-black shadow-[6px_6px_0_#000]"
                            >
                                <h3 className="mb-4 inline-block bg-red-500 px-3 py-1 text-sm font-black uppercase text-white shadow-[3px_3px_0_#000]">
                                    {group.title}
                                </h3>

                                <ul className="space-y-2">
                                    {group.links.map((link) => (
                                        <li key={link.label}>
                                            <a
                                                href={link.href}
                                                target={
                                                    link.href.startsWith("http")
                                                        ? "_blank"
                                                        : undefined
                                                }
                                                rel={
                                                    link.href.startsWith("http")
                                                        ? "noreferrer"
                                                        : undefined
                                                }
                                                className="font-bold text-black underline decoration-cyan-400 decoration-2 underline-offset-4 transition hover:text-red-500"
                                            >
                                                {link.label}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                </div>

                <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t-[3px] border-white/20 pt-6 text-center text-xs font-bold uppercase tracking-wide text-white/70 sm:flex-row">
                    <p>© 2026 Call It Out. All rights reserved.</p>
                    {/* <p>Work in Progress</p> */}
                </div>
            </div>
        </footer>
    );
};